import { render, staticRenderFns } from "./order-status-select.vue?vue&type=template&id=c21df5ec&"
import script from "./order-status-select.vue?vue&type=script&lang=js&"
export * from "./order-status-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports